import { signOutAsync } from '../pages/auth/api';
import { signOutUser } from '../pages/auth/contexts/actions';

const signOut = async (authDispatch) => {
  await signOutAsync();
  authDispatch(signOutUser());
};

export default signOut;
